export const screenSize = {
  xxl: 1280,
  xl: 1199,
  lg: 991,
  md: 767,
  sm: 575,
  ssm: 480,
  xs: 380,
  xxs: 320,
};
